<div class="d-flex align-items-center">
  <div class="col-5 asset-card-content-title">{{ attributeValue.name }}</div>
  <div class="col-7 asset-card-content-value">
    <ng-container [ngSwitch]="getRenderType(attributeValue.type)">
      <span *ngSwitchCase="'string'">{{
        attributeValue.stringValue | hasValue
      }}</span>
      <span *ngSwitchCase="'number'">{{
        attributeValue.doubleValue | number
      }}</span>
      <span *ngSwitchCase="'date'">{{
        attributeValue.dateValue | date : getDateFormat(attributeValue)
      }}</span>
      <span *ngSwitchCase="'bool'">{{
        (attributeValue.boolValue ? "COMMON.YES" : "COMMON.NO") | translate
      }}</span>
      <span *ngSwitchDefault>{{ attributeValue.stringValue | hasValue }}</span>
    </ng-container>
  </div>
</div>
